<script setup lang="ts">
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import OfficeEditorView from '@/views/app/OfficeEditorView.vue'
  import { ROUTES } from '@/router/routes'
  import { ResourceTypeEnum } from '@/types/generated'

  const route = useRoute()
  const templateUuid = computed(() => route.params.uuid as string)
  const gobackUrl = computed(() =>
    ROUTES.ADMIN.WORD_TEMPLATES.REVIEW_DETAIL.replace(':uuid', templateUuid.value)
  )
</script>

<template>
  <OfficeEditorView
    :documentUuid="templateUuid"
    :resourceType="ResourceTypeEnum.WORD_TEMPLATE"
    :gobackUrl="gobackUrl"
  />
</template>
